import Inserted from "@sudowrite/extension-inserted";
import Bold from "@tiptap/extension-bold";
import BulletList from "@tiptap/extension-bullet-list";
import TipTapDocument from "@tiptap/extension-document";
import Hardbreak from "@tiptap/extension-hard-break";
import Heading from "@tiptap/extension-heading";
import { ThemeAwareHighlight } from "../../../lib/tipTapExtensions/themeAwareHighlight";
import Image from "@tiptap/extension-image";
import Italic from "@tiptap/extension-italic";
import Link from "@tiptap/extension-link";
import ListItem from "@tiptap/extension-list-item";
import Paragraph from "@tiptap/extension-paragraph";
import Strike from "@tiptap/extension-strike";
import Text from "@tiptap/extension-text";
import TiptapHistory from "@tiptap/extension-history";
import Typography from "@tiptap/extension-typography";
import Underline from "@tiptap/extension-underline";
import Annotation from "../../../../../src/shared/annotation";
import { InsertionMark, DeletionMark } from "../../../../../src/shared/trackChanges";
import { createReadOnlyPlaceholder } from "../../../lib/tipTapExtensions/readOnlyPlaceholder";
import { createTaskListExtensions } from "../../../lib/tipTapExtensions/taskListExtensions";

export function getFirstNonEmptyText(content) {
  if (!content) return "";

  const visit = (node) => {
    if (!node) return "";
    if (typeof node.text === "string" && node.text.trim()) {
      return node.text.trim();
    }

    const children = Array.isArray(node.content) ? node.content : [];
    for (const child of children) {
      const text = visit(child);
      if (text) return text;
    }

    return "";
  };

  return visit(content);
}

export function createHistoryPreviewExtensions() {
  return [
    TipTapDocument,
    // Real <p> elements (not the historical <div> override) so the preview
    // picks up the shared editor typography rules — paragraph spacing,
    // list bullets (drawn on `li > p:first-child`), and indent.
    Paragraph,
    Text,
    Bold,
    Italic,
    Heading,
    Underline,
    Hardbreak,
    Strike,
    ThemeAwareHighlight.configure({
      multicolor: true,
    }),
    BulletList,
    Typography,
    ListItem,
    ...createTaskListExtensions({ canWrite: false }),
    Inserted,
    Link,
    Image.configure({
      inline: true,
    }),
    TiptapHistory,
    createReadOnlyPlaceholder(),
    Annotation.configure(),
    InsertionMark,
    DeletionMark,
  ];
}
